import { formatINR } from "@/lib/api";
import { Clock, MapPin, Pencil, Trash2 } from "lucide-react";

export default function DoctorManagement({ doctors, onEdit, onDelete }) {
  return (
    <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-5" data-testid="doctors-manage-grid">
      {doctors.map((d) => (
        <div key={d.id} data-testid="doctor-manage-card" className="bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col">
          <div className="flex gap-4 p-5">
            <img src={d.avatar} alt={d.name} className="h-16 w-16 rounded-xl object-cover" />
            <div className="min-w-0 flex-1">
              <div className="font-head font-bold text-slate-900">{d.name}</div>
              <div className="text-sm text-teal-700">{d.specialty}</div>
              <div className="text-sm font-mono text-slate-600 mt-1">{formatINR(d.fee)}</div>
            </div>
          </div>
          <div className="px-5 pb-4 space-y-2 text-sm text-slate-500 flex-1">
            {d.about && <p className="line-clamp-2">{d.about}</p>}
            {(d.available_days || d.available_hours) && (
              <div className="flex items-start gap-2"><Clock className="h-4 w-4 text-teal-600 mt-0.5 shrink-0" />{d.available_days} • {d.available_hours}</div>
            )}
            {d.location && <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-teal-600 mt-0.5 shrink-0" />{d.location}</div>}
          </div>
          <div className="flex border-t border-slate-100">
            <button data-testid="edit-doctor-button" onClick={() => onEdit(d)}
              className="flex-1 py-3 text-sm font-medium text-slate-600 hover:bg-slate-50 flex items-center justify-center gap-2">
              <Pencil className="h-4 w-4" /> Edit
            </button>
            <button data-testid="delete-doctor-button" onClick={() => onDelete(d.id)}
              className="flex-1 py-3 text-sm font-medium text-rose-600 hover:bg-rose-50 flex items-center justify-center gap-2 border-l border-slate-100">
              <Trash2 className="h-4 w-4" /> Remove
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
